import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";
import pure from "recompose/pure";

const CalendarIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <rect x="1" y="3" width="14" height="12" rx="1" fill='none' stroke="#2B3940" strokeWidth="2" />
    <line x1="4" y1="2" x2="4" y2="1" stroke="#2B3940" fill='none' strokeWidth="2" strokeLinecap="round" />
    <line x1="12" y1="2" x2="12" y2="1" stroke="#2B3940" fill='none' strokeWidth="2" strokeLinecap="round" />
    <line x1="1" y1="6" x2="14" y2="6" stroke="#2B3940" fill='none' strokeWidth="2" />
  </SvgIcon>
);
CalendarIcon.displayName = "CalendarIcon";
CalendarIcon.muiName = "SvgIcon";

export default pure(CalendarIcon);